import { render } from "./TextInput.vue?vue&type=template&id=8223fe42&scoped=true"
import script from "./TextInput.vue?vue&type=script&lang=js"
export * from "./TextInput.vue?vue&type=script&lang=js"

import "./TextInput.vue?vue&type=style&index=0&id=8223fe42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8223fe42"]])

export default __exports__